import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Projects = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Unsere Referenzen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Überzeugen Sie sich von der Qualität unserer Arbeit. Diese Projekte zeigen unser Können und unsere Erfahrung.
          </p>
        </motion.div>

        {/* Elfsight Portfolio Widget */}
        {/* Container mit min-height, damit der Bereich nicht kollabiert, falls das Widget lädt oder kurzzeitig unsichtbar ist */}
        <div className="min-h-[500px] w-full">
          <div className="elfsight-app-30223f2c-0190-440b-8d23-2904de66dc34" data-elfsight-app-lazy></div>
        </div>
      </div>
    </section>
  );
};

export default Projects;